// src/pages/SaganQuotes/SaganQuotes.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './SaganQuotes.scss'
import { useRefs } from '../../context/RefContext'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Trans } from "@lingui/react/macro";

const SaganQuotes = () =>
{
    useEffect(() =>
    {
        Aos.init({ duration: 1000, once: true, easing: 'ease-in-out' });
    }, [])

    const { saganRef } = useRefs()
    
    return (
        <div ref={saganRef} className='sagan-quotes'>
                <div className='orbit-graphic-container'>
              <div className='orbit-circle outer-ring'></div>
                  <div className='orbit-circle inner-planet'></div>
                  {/* We can add the small orbiting dot later */}
                </div>

            <div className='sagan-quotes_container'>

                {/* Quote 1 */}
                <div className='sagan-quote-item quote-pos-1' data-aos='fade-right' data-aos-duration="3000">
                    <p className='quote-text'><Trans>
              {'\u201c'}Dentro de un milenio nuestra época se recordará como el tiempo en que nos alejamos por primera vez de la Tierra y la contemplamos desde más allá del último de los planetas, como un <strong><em>punto azul</em></strong> pálido casi perdido <strong>en un inmenso mar de estrellas.</strong>{'\u201d'}</Trans></p>    
                </div>

                {/* Quote 2 */}
                <div className='sagan-quote-item quote-pos-2' data-aos='fade-right' data-aos-duration="3000">
                 <p className='quote-text quote-outline'><Trans>
              {'\u201c'}LA EXPLORACIÓN ESTÁ<br />EN NUESTRA NATURALEZA{'\u201d'}
                </Trans></p>    
                </div>
                

                {/* Quote 3 */}
                <div className='sagan-quote-item quote-pos-3' data-aos='fade-right' data-aos-duration="3000">
                    <p className='quote-text'><Trans>
                    {'\u201c'}<strong><em>La superficie de la Tierra es la orilla del océano cósmico.</em></strong> Desde ella hemos aprendido la mayor parte de lo que sabemos. Recientemente nos hemos adentrado un poco en el mar […]. El océano nos llama.<br /><strong>Hay una parte de nuestro ser que sabe que venimos de allí.</strong>{'\u201d'}
                    </Trans></p>   
                </div>

                {/* Quote 4 */}
                <div className='sagan-quote-item last-sagan-quote' data-aos='fade-right' data-aos-duration="3000">
                    <p className='quote-text'><Trans>
                    {'\u201c'}Hemos permanecido bastante tiempo en las orillas del océano cósmico.<br /><strong>ESTAMOS LISTOS</strong> por fin para navegar hacia las estrellas.{'\u201d'}
                    </Trans></p>    
                </div>

                {/* Carl Sagan attribution - now after all quotes */}
                <div className='sagan-attribution' data-aos='fade-in'> {/* Changed to zoom-in for a different effect */}
                    <p className='attribution-text'> — Carl Sagan</p>
                </div>
                {/* Spacing */}
                <div className='intraquote-space'></div>
                {/* Quote Drucker */}
                <div className='sagan-quote-item drucker-quote' data-aos='fade-right' data-aos-duration="3000">
                    <p className='quote-text'><Trans>
                    {'\u201c'}La mejor manera de predecir el futuro es <strong>creándolo.</strong>{'\u201d'}
                    </Trans></p>    
                </div>
                
                {/* Carl Sagan attribution - now after all quotes */}
                <div className='sagan-attribution' data-aos='fade-in'> {/* Changed to zoom-in for a different effect */}
                    <p className='attribution-text'> — Peter Drucker</p>
                </div>

            </div>
        </div>
    );
};

export default SaganQuotes
